var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.334 4.333a.667.667 0 1 1 1.334 0 .667.667 0 0 1-1.334 0Zm0 2a.667.667 0 0 1 1.333 0v3.334a.667.667 0 0 1-1.333 0V6.333Zm.667 6A5.34 5.34 0 0 1 1.667 7a5.34 5.34 0 0 1 5.334-5.333A5.34 5.34 0 0 1 12.334 7a5.34 5.34 0 0 1-5.333 5.333Zm0-12a6.667 6.667 0 1 0 0 13.333A6.667 6.667 0 0 0 7 .333Z",
    fill: "#008545"
  })));
};
export default SvgInfo;